export default "__VITE_ASSET__3f2462ed__"